// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import VehicleInspection from './VehicleInspection';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(VehicleInspection);
